/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Available_TitleInputs */

const en_directory_integrate_available_title = /** @type {(inputs: Directory_Integrate_Available_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available now`)
};

const zh_directory_integrate_available_title = /** @type {(inputs: Directory_Integrate_Available_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前可用`)
};

/**
* | output |
* | --- |
* | "Available now" |
*
* @param {Directory_Integrate_Available_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_available_title = /** @type {((inputs?: Directory_Integrate_Available_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Available_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_available_title(inputs)
	return zh_directory_integrate_available_title(inputs)
});
export { directory_integrate_available_title as "directory.integrate.available_title" }